import { trackElement } from '@fff-web/fff-analytics';
import { useViewSize } from '@fff-web/fff-utilities';
import { FooterLink, LinkShape } from '../../services/types';
import { setHref } from '../../utils/location';
import { AccordionFooterLink } from '../AccordionFooterLink';
import './LinkFooter.scss';
import { LinkItem } from '../LinkItem/LinkItem';

interface Props {
  categories: FooterLink[];
}

const LinkFooter = ({ categories }: Props) => {
  const { isMobile } = useViewSize();

  const handleOnClickMenuLink = ({ trakingName }: LinkShape, path: string) => {
    if (trakingName) {
      trackElement({
        elementName: trakingName,
        callback: () => {
          setHref(path);
        },
      });
    } else {
      setHref(path);
    }
  };

  return (
    <div className="fff-shared-linkFooter-container">
      {categories.map(({ id, header, links }) => (
        <div className="fff-shared-linkFooter-item" key={id}>
          {isMobile ? (
            <AccordionFooterLink
              key={id}
              header={header}
              items={links}
              handleOnClickMenuLink={handleOnClickMenuLink}
            />
          ) : (
            <div className="fff-shared-linkFooter-column">
              <span className="fff-shared-linkFooter-column-header">{header}</span>
              {links.map((item) => (
                <LinkItem
                  key={item.id}
                  link={item}
                  className="fff-shared-linkFooter-column-item"
                  handleOnClick={handleOnClickMenuLink}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export { LinkFooter };
